import { Space, Table } from "antd";
// import { SearchOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { get } from "../../../services";

const Usertable = () => {
  const [userData, setUserData] = useState([]);
  const [loader, setLoader] = useState(true);

  // method for API call
  const getUserHandler = () => {
    setLoader(true);
    //axios call
    get(`/hr/salary`)
      .then((response) => {
        setUserData(response?.data);
        console.log(response);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };

  //  API for user
  useEffect(() => {
    getUserHandler();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "_id",
      key: "_id",
      render: (_, __, index) => <Space>{index + 1}</Space>,
    },
    {
      title: "Name",
      dataIndex: "",
      key: "",
      render: (data) => (
        <div>
          <Space size="middle">{data?.employee?.name}</Space>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "",
      key: "",
      render: (data) => <Space size="middle">{data?.employee?.email}</Space>,
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <Space>
          <Link to={`/salary-details/${data?.employee?._id}`}>
            View Details
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="header" style={{ paddingBottom: "15px" }}>
        <h3>Salary Details</h3>
        <div className="events-button">
          <Link to="/add-salary">
            <button className="cursor-pointer add-event">
              Add Employee Salary
            </button>
          </Link>
        </div>
      </div>
      {/* table */}
      <div>
        <Table
          columns={columns}
          dataSource={userData?.salariesResponse}
          loading={loader}
          pagination={false}
          scroll={{ x: 1023 }}
        />
      </div>
    </div>
  );
};
export default Usertable;
